<template>
  <div class="spinner-overlay">
    <div class="modern-spinner"></div>
  </div>
</template>

<style scoped>
.spinner-overlay {
  /* Full-screen overlay */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  
  /* Using a slightly more transparent background */
  background-color: rgba(255, 255, 255, 0.5); /* Semi-transparent white */
  
  /* Reduced blur for a more subtle effect */
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px); /* For Safari browser support */

  /* Centering the spinner */
  display: flex;
  justify-content: center;
  align-items: center;

  /* Ensure it's on top of all other content */
  z-index: 9999;
}

/* A more modern spinner animation */
.modern-spinner {
  /* Reduced spinner size */
  width: 40px;
  height: 40px;
  border-radius: 50%;
  
  /* Adjusted border size to match */
  border: 4px solid #e9ecef; /* A very light grey */
  border-top-color: #0d6efd; /* Your theme's primary blue */
  animation: modern-spin 1s linear infinite;
}

@keyframes modern-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>